import * as React from 'react';


const Support = (props) => {
  const { className } = props;

  return (
    <div className="sett__view">
      <h3 className="sett__title">Support</h3>
      <p className="sett__text">Have a question, comment or complaint about Relay?</p>

      <div className="note--info note--inline">
        <div className="note--info__item">
          <span className="note--info__lbl">Help Site:</span>
          <a href="http://help.relaypayments.com/" className="note--info__text" target="blank">http://help.relaypayments.com/</a>
        </div>
      </div>
      <div className="note--info note--inline">
        <div className="note--info__item">
          <span className="note--info__lbl">General Inquiries:</span>
          <a href="tel:+18777352910" className="note--info__text">1-877-735-2910 (1-877-RELAY10)</a>
        </div>
        <div className="note--info__item">
          <span className="note--info__lbl">Customer Support:</span>
          <a href="tel:+14703540934" className="note--info__text">1-470-354-0934</a>
        </div>
      </div>
      <div className="note--info note--inline">
        <div className="note--info__item">
          <span className="note--info__lbl">Email:</span>
          <a href="mailto:help@relaypayments.com" className="note--info__text">help@relaypayments.com</a>
        </div>
      </div>
    </div>
  );
};

export default Support;
